import { CloseIcon } from '../assets/icons';
import { DivButton } from '../commons/components/DivButton';
import React, { PropsWithChildren, useState } from 'react';
import { useTimeout } from '../hooks/useTimeout';

export const StickyNote = (props: PropsWithChildren) => {
  const { children } = props;
  const [isClosed, setIsClosed] = useState(false);
  useTimeout(() => setIsClosed(true), 10_000);
  if (isClosed) return null;
  return (
    <div className="sticky-note">
      <div className="sticky-note__content">
        <div className="sticky-note__arrow-left" />
        <div className="sticky-note__body">
          {children}
          <DivButton
            icon={<CloseIcon />}
            onClick={() => setIsClosed(true)}
            dataTest="sticky-note__close-button"
            className="sticky-note__close-button"
          />
        </div>
      </div>
    </div>
  );
};
